const ip = "https://ebudgetmanipur.mn.gov.in/webapi";
// const ip = "http://10.178.7.44";
// const ip = "http://localhost/ebudgetapi/public";
export const MENU_HEADER_URL = ip+"/budget/menu";
export const REVISED_DEMANDS_FOR_GRANTS_URL = ip+"/budget/reviseddemands";
export const DEMANDS_FOR_GRANTS_URL = ip+"/budget/demands";
export const APPROPRIATION_BY_DEMAND_URL = ip+"/budget/getAppropriationByDemandNo";
export const REVISED_APPROPRIATION_BY_DEMAND_URL = ip+"/budget/getRevisedAppropriationByDemandNo";
export const MENU_BY_ID = ip+"/budget/getMenuById";
export const REVISED_UPLOAD_URL = ip+"/budget/upload";
export const UPLOAD_URL = ip+"/budget/upload";
export const UPLOAD_MENU_URL = ip+"/budget/uploadmenu";
export const UPLOAD_FULL_URL = ip+"/budget/uploadfull";
export const REVISED_UPLOAD_FULL_URL = ip+"/budget/uploadfull";
export const FINYEAR_LIST_URL = ip+"/budget/finyearlist";
export const LOGIN_URL = ip+"/budget/login";
export const AUTH_URL = ip+"/budget/user";
export const CHANGEPWD_URL = ip+"/budget/changepwd";
export const DOCUMENT_LIST = ip+"/budget/documents";
export const DOWNLOAD_URL = ip+"/budget/download";
export const LOG_URL = ip+"/budget/getlog";
export const DELETE_URL = ip+"/budget/menu/delete";
export const PASSWD_DAYS = 180;